import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { client } from '../client';

function unwrapApiResponse(data: any): any {
  if (data && typeof data === 'object' && 'success' in data && 'data' in data) return data.data;
  return data;
}

export const useWorkspaces = (organizationId: string) => {
  return useQuery({
    queryKey: ['workspaces', organizationId],
    queryFn: () => client.get('/workspaces', { params: { organizationId } }).then(r => r.data).then(unwrapApiResponse),
    enabled: !!organizationId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useWorkspace = (id: string, organizationId: string) => {
  return useQuery({
    queryKey: ['workspace', id],
    queryFn: () => client.get(`/workspaces/${id}`, { params: { organizationId } }).then(r => r.data).then(unwrapApiResponse),
    enabled: !!id && !!organizationId,
  });
};

export const useWorkspaceMembers = (workspaceId: string) => {
  return useQuery({
    queryKey: ['workspace-members', workspaceId],
    queryFn: () => client.get(`/workspaces/${workspaceId}/members`).then(r => r.data).then(unwrapApiResponse),
    enabled: !!workspaceId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useWorkspaceMembership = (workspaceId: string) => {
  return useQuery({
    queryKey: ['workspace-membership', workspaceId],
    queryFn: () => client.get(`/workspaces/${workspaceId}/membership`).then(r => r.data).then(unwrapApiResponse),
    enabled: !!workspaceId,
    staleTime: 1000 * 60 * 5,
  });
};